import { call, put } from '@redux-saga/core/effects'
import axios from 'axios'
import { roomCreate } from '../../../api/roomCreate'
import { roomCreateError, roomCreateSuccess } from '../../../actions/rooms/actions'
import { Action } from '../../../../common/store/sagas/root'
import { Room } from '../../../types'

export function* sagaRoomCreate({ payload }: Action<Room>) {
  try {
    const response: Room = yield call(roomCreate, payload)
    yield put(roomCreateSuccess(response))
  } catch (error) {
    if (axios.isAxiosError(error) && error.response) {
      yield put(roomCreateError(error.response.data as unknown))
    } else {
      yield put(roomCreateError(error))
      throw error
    }
  }
}
